import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FundFollowButton from '../fund-follow-button';
import { SectionSubTitle } from '../../../shared/sectionable/styles';

const Container = styled.div`
  & > button {
    margin-top: 24px;
  }
`;

const Text = styled(SectionSubTitle)`
  font-size: 21px;
  line-height: 130%;
  margin-top: ${props => (props.theme.isMobile ? 64 : 24)}px;
  padding-bottom: 0px;
  color: ${props => props.theme.bodyColor};
`;

export default function Follow({ fund }) {
  return (
    <Container>
      <Text>
        {`Stay up to date with ${fund.name}`}
      </Text>
      <FundFollowButton fund={fund} />
    </Container>
  );
}

Follow.propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    isFollowedByCurrentUser: PropTypes.bool.isRequired,
  }).isRequired,
};
